import * as angular from 'angular';
class TooltipHelp {
    [x: string]: any;
 	 static $inject = ['$window'];
    constructor($window) {
        this.window = $window;
        this.tooltipArrowHeight = 20;
        this.tooltipWidht = 350;
        this.tooltipMargintTop = 30;
        this.tooltipArrow = '.tooltip-arrow';
    };


    setPosition(from, tooltipTopValue, tooltipLeftValue, arrowTopValue, arrowLeftValue) {
        if (from === 'top') {
            this.tooltip.css({'top': tooltipTopValue, 'left': tooltipLeftValue});
            this.arrow.css({'top': arrowTopValue, 'left': arrowLeftValue});
        } else {
            this.tooltip.css({'bottom': tooltipTopValue, 'left': tooltipLeftValue});
            this.arrow.css({'bottom': arrowTopValue, 'left': arrowLeftValue});
        }

    };

    tooltipPosition(event) {
        this.displayHeight = this.window.innerHeight || 0;
        this.mousePositionY = (event) ? event.clientY : 0;
        this.mousePositionX = (event) ? event.clientX : 0;
        this.tooltip = angular.element(event.currentTarget).next();
        this.arrow = this.tooltip.find(this.tooltipArrow);
        if (this.displayHeight / 2 - this.mousePositionY > 0) {
            this.setPosition('top', this.mousePositionY - this.tooltipMargintTop, this.mousePositionX - this.tooltipWidht, this.mousePositionY - this.tooltipArrowHeight/2, this.mousePositionX - this.tooltipArrowHeight);
        } else {
            this.setPosition('bottom',  this.displayHeight-this.mousePositionY - this.tooltipMargintTop, this.mousePositionX - this.tooltipWidht, (this.displayHeight-this.mousePositionY - this.tooltipArrowHeight/2), this.mousePositionX - this.tooltipArrowHeight);
        }
    };
}

export default {
    controller: TooltipHelp,
    template : require('./tooltip.help.html'),
    bindings: {
        content: '<'
    }
};
